import { render, staticRenderFns } from "./RefineWidgetsDesktop.vue?vue&type=template&id=02388447&scoped=true"
import script from "./RefineWidgetsDesktop.vue?vue&type=script&lang=js"
export * from "./RefineWidgetsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02388447",
  null
  
)

export default component.exports